<div [formGroup]="equipmentForm">
    <div class="row">
        <div class="col-lg-5 col-12 order-2 order-lg-1">
            <div class="row g-0">
                <label
                    class="col-12 col-lg-5 col-form-label text-start text-lg-end pe-4"
                    translate="CONFIRMATION_EQUIPMENT_LABEL"
                ></label>
                <div class="col-12 col-lg-7">
                    <pace-core-dropdown
                        [(model)]="model.equipments"
                        [parentForm]="equipmentFormChildren"
                        (valueChange)="model.onEquipmentChange()"
                    ></pace-core-dropdown>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-12 offset-lg-1 order-1 order-lg-2">
            <div class="row">
                <div class="col-lg-6 col-12 mb-3 d-flex align-items-center">
                    <span class="col-lg-5 col-6">{{ technicalIdOrFunctionalLocationLabel }}</span>
                    <span class="col-lg-7 col-6 text-end text-lg-start">
                        {{ model.equipments.selectedEntry.model.tidnr.value }}
                    </span>
                </div>
                <div class="col-lg-6 col-12 mb-3 d-flex align-items-center">
                    <span class="col-lg-5 col-6" translate="CONFIRMATION_EQUIPMENT_MATERIAL_LABEL"></span>
                    <span class="col-lg-7 col-6 text-end text-lg-start">
                        {{ model.equipments.selectedEntry.model.matnr.value }}
                    </span>
                </div>
                <div class="col-lg-6 col-12 mb-3 d-flex align-items-center">
                    <span class="col-lg-5 col-6" translate="CONFIRMATION_EQUIPMENT_SERIAL_LABEL"></span>
                    <span class="col-lg-7 col-6 text-end text-lg-start">
                        {{ model.equipments.selectedEntry.model.sernr.value }}
                    </span>
                </div>
                <div class="col-lg-6 col-12 mb-3 d-flex align-items-center">
                    <span class="col-lg-5 col-6" translate="CONFIRMATION_EQUIPMENT_CONTRACT_LABEL"></span>
                    <span class="col-lg-7 col-6 text-end text-lg-start">
                        {{ model.equipments.selectedEntry.model.contractType.value }}
                    </span>
                </div>
                @if (model.affectedEquipment.length > 0) {
                    <div class="col-12 d-flex align-items-center">
                        <span class="col-lg-5 col-6" translate="CONFIRMATION_EQUIPMENT_AFFECTED_EQUIPMENT_LABEL"></span>
                        <span class="col-lg-7 col-6 text-end text-lg-start">{{ model.affectedEquipment }}</span>
                    </div>
                }
            </div>
        </div>
    </div>

    <hr class="separator" />

    <div class="row mb-3">
        <label
            class="col-lg-2 col-12 col-form-label text-start text-lg-end"
            translate="CONFIRMATION_EQUIPMENT_STATUS_IN_ARRIVAL_LABEL"
        ></label>
        <div class="col-lg-3 col-12 d-flex align-items-center">
            @if (model.isCriticalityChangeEnabled) {
                <span>{{ model.criticality }}</span>
            }
            @if (!model.isCriticalityChangeEnabled) {
                <pace-core-dropdown
                    class="col-12"
                    [(model)]="model.statusInArrival"
                    [parentForm]="equipmentFormChildren"
                    (valueChange)="updateStatusInArrivalFields()"
                ></pace-core-dropdown>
            }
        </div>

        @if (displayStartDownTime) {
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_DOWN_TIME_START_LABEL"
            ></label>
            <div class="col-lg-5 col-12">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <pace-core-date-input
                            [(model)]="model.downTimeStartDate"
                            (valueChange)="onDownTimeStartChange($event)"
                            [parentForm]="equipmentFormChildren"
                            [ariaLabel]="('CONFIRMATION_EQUIPMENT_DOWN_TIME_START_LABEL' | translate) + 'Date'"
                        ></pace-core-date-input>
                    </div>
                    <div class="col-lg-6 col-12 mt-lg-0 mt-2">
                        <div class="d-flex align-items-center gap-2">
                            <div class="flex-grow-1 col-lg-12">
                                <pace-core-time-input
                                    [(model)]="model.downTimeStartTime"
                                    (valueChange)="onDownTimeStartChange($event)"
                                    [parentForm]="equipmentFormChildren"
                                    [ariaLabel]="('CONFIRMATION_EQUIPMENT_DOWN_TIME_START_LABEL' | translate) + 'Time'"
                                ></pace-core-time-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="row mb-3">
        @if (displayStatusAfterFix) {
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_STATUS_AFTER_FIX_LABEL"
            ></label>
            <div class="col-lg-3 col-12">
                <pace-core-dropdown
                    [(model)]="model.statusAfterFix"
                    (valueChange)="updateTimeOfRecoveryFields()"
                    [parentForm]="equipmentFormChildren"
                ></pace-core-dropdown>
            </div>
        }
        @if (displayTimeAndDateOfRecovery) {
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_TIME_OF_RECOVERY_LABEL"
            ></label>
            <div class="col-lg-5 col-12">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <pace-core-date-input
                            [(model)]="model.timeOfRecoveryDate"
                            (valueChange)="onTimeOfRecoveryChange($event)"
                            [parentForm]="equipmentFormChildren"
                            [ariaLabel]="('CONFIRMATION_EQUIPMENT_TIME_OF_RECOVERY_LABEL' | translate) + 'Date'"
                        ></pace-core-date-input>
                    </div>
                    <div class="col-lg-6 col-12 mt-lg-0 mt-2">
                        <div class="flex-grow-1">
                            <pace-core-time-input
                                [(model)]="model.timeOfRecoveryTime"
                                (valueChange)="onTimeOfRecoveryChange($event)"
                                [parentForm]="equipmentFormChildren"
                                [ariaLabel]="('CONFIRMATION_EQUIPMENT_TIME_OF_RECOVERY_LABEL' | translate) + 'Time'"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="row align-items-center mb-3">
        @if (model.showApprover) {
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                for="approverInput"
                translate="NOTIFICATION_DETAILS_CRITICALITY_APPROVER_LABEL"
            ></label>
            <div class="col-lg-3 col-12">
                <pace-core-text-input
                    id="approverInput"
                    [parentForm]="equipmentFormChildren"
                    [(model)]="model.approver"
                    [ariaLabel]="'NOTIFICATION_DETAILS_CRITICALITY_APPROVER_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        }
        @if (displayTimeAndDateOfRecovery) {
            <label
                class="col-lg-2 col-md-4 col-5 col-form-label text-start text-lg-end"
                [ngClass]="{ 'offset-lg-5': !model.showApprover }"
                translate="CONFIRMATION_EQUIPMENT_NO_DOWNTIME_LABEL"
            ></label>
            <div class="col-lg-3 col-auto">
                <pace-core-checkbox-input
                    id="noDownTime"
                    [(model)]="model.noDowntimeDurationFlag"
                    (valueChange)="syncDateTime()"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_NO_DOWNTIME_LABEL' | translate"
                >
                </pace-core-checkbox-input>
            </div>
        }
        @if (displayDowntimeDuration && durationDifference.asSeconds() >= 0) {
            <label
                class="col-lg-2 offset-lg-5 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_DOWNTIME_DURATION_LABEL"
            ></label>
            <div class="col-lg-5 col-12">
                <div class="row align-items-center">
                    <div
                        class="col-auto col-lg-6 downtime-duration-text"
                        [ngClass]="{
                            'downtime-max-hour-exceeded':
                                !model.downtimeDurationAcknowledged.model.value && downtimeDurationExceeded,
                        }"
                    >
                        {{ downtimeDuration }}
                    </div>
                    <div class="col-lg-6 col-12">
                        @if (downtimeDurationExceeded) {
                            <pace-core-checkbox-input
                                id="downtimeDuration"
                                [(model)]="model.downtimeDurationAcknowledged"
                                (valueChange)="updateDowntimeDurationValidation()"
                                [parentForm]="equipmentFormChildren"
                                [ariaLabel]="'CONFIRMATION_EQUIPMENT_SYNC_VALIDATE_DOWNTIME_ARIA_LABEL' | translate"
                            >
                            </pace-core-checkbox-input>
                        }
                    </div>
                </div>
            </div>
        }
    </div>

    <hr class="separator" />

    @if (model.troubleTextLong) {
        <div class="row mb-3" id="divTroubleText">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_TROUBLE_TEXT_LABEL"
            ></label>
            <div class="col-lg-8 col-12">
                <pace-core-text-input
                    [(model)]="model.troubleTextLong"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_TROUBLE_TEXT_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }

    <div class="row mb-3">
        <label
            class="col-lg-2 col-12 col-form-label text-start text-lg-end"
            translate="CONFIRMATION_EQUIPMENT_REPORT_CODE_LABEL"
        ></label>
        <div [ngClass]="{ 'col-lg-8 col-12': !model.maxOneSelection, 'col-lg-4 col-12': model.maxOneSelection }">
            <pace-core-dropdown [(model)]="model.reportCodes" [parentForm]="equipmentFormChildren"></pace-core-dropdown>
        </div>
    </div>

    <div class="row mb-3">
        <label
            class="col-lg-2 col-12 col-form-label text-start text-lg-end"
            translate="CONFIRMATION_EQUIPMENT_REPORT_TEXT_LABEL"
        ></label>
        <div class="col-lg-8 col-12">
            <pace-core-text-input
                [(model)]="model.reportTextLong"
                [parentForm]="equipmentFormChildren"
            ></pace-core-text-input>
        </div>
    </div>
    <hr class="separator" />

    @if (model.phiDataCode) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_PHI_DATA_CODE_LABEL"
            ></label>
            <div class="col-lg-3 col-12">
                <pace-core-dropdown
                    [(model)]="model.phiDataCode"
                    [parentForm]="equipmentFormChildren"
                ></pace-core-dropdown>
            </div>
        </div>
    }
    @if (model.phiDataCode) {
        <hr class="separator" />
    }

    @if (model.showInfoToCCC) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_INFO_TO_CC_LABEL"
            ></label>
            <div class="col-lg-8 col-12">
                <pace-core-text-input
                    [(model)]="model.infoToCCC"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_INFO_TO_CC_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }

    @if (model.showInfoToCCC) {
        <hr class="separator" />
    }

    @if (model.showCommercialInfo) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_COMMERCIAL_INFO_LABEL"
            ></label>
            <div class="col-lg-8 col-12">
                <pace-core-dropdown
                    [(model)]="model.commercialInfoCodes"
                    [parentForm]="equipmentFormChildren"
                    (valueChange)="validateCommercialInfo()"
                ></pace-core-dropdown>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-8 offset-lg-2 col-12">
                <pace-core-text-input
                    [(model)]="model.commercialInfoDesc"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_COMMERCIAL_INFO_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <hr class="separator" />
    }

    @if (model.reasonsCode || model.reasonsCodeFallback) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_REASON_LABEL"
            ></label>
            @if (model.reasonsCode) {
                <div class="col-lg-6 col-12">
                    <pace-core-tree-view
                        [(model)]="model.reasonsCode"
                        [parentForm]="equipmentFormChildren"
                    ></pace-core-tree-view>
                </div>
            }
            <!-- The following div is useful for debugging the selected entry-->
            <!--<div class="col-4" *ngIf="model.reasonsCode">
      Title: {{model.reasonsCode.selectedEntry ? model.reasonsCode.selectedEntry.value : ''}}<br>
      Group: {{model.reasonsCode.selectedEntry ? model.reasonsCode.selectedEntry.payload.codeGroup.value : ''}}
    </div>-->
            @if (model.reasonsCodeFallback) {
                <div class="col-lg-3 col-12">
                    <pace-core-dropdown
                        [(model)]="model.reasonsCodeFallback"
                        [parentForm]="equipmentFormChildren"
                    ></pace-core-dropdown>
                </div>
            }
        </div>
    }

    @if (
        model.reasonsCode &&
        model.reasonsCode.selectedEntry &&
        model.reasonsCode.selectedEntry.payload.codeGroup.value.indexOf(model.assayIndicator) === 0
    ) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_ASSAY_NUMBER_LABEL"
            ></label>
            <div class="col-lg-4 col-12">
                <pace-core-text-input
                    [(model)]="model.assayNumber"
                    (valueChange)="validateForm()"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_ASSAY_NUMBER_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_LOT_NUMBER_LABEL"
            ></label>
            <div class="col-lg-4 col-12">
                <pace-core-text-input
                    [(model)]="model.lotNumber"
                    (valueChange)="validateForm()"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_LOT_NUMBER_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }

    @if (model.srsVpnConnection) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_SRS_VPN_CONNECTION_LABEL"
            ></label>
            <div class="col-lg-8 col-12">
                <pace-core-dropdown
                    [(model)]="model.srsVpnConnection"
                    [parentForm]="equipmentFormChildren"
                ></pace-core-dropdown>
            </div>
        </div>
    }
    @if (model.srsVpnConnection) {
        <hr class="separator" />
    }

    @if (model.checkInOutName) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_CHECK_IN_CHECK_OUT_NAME_LABEL"
            ></label>
            <div class="col-lg-8 col-12">
                <pace-core-text-input
                    [(model)]="model.checkInOutName"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_CHECK_IN_CHECK_OUT_NAME_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }
    @if (model.checkInOutName) {
        <hr class="separator" />
    }

    @if (model.checkInOutPhone) {
        <div class="row mb-3">
            <label
                class="col-lg-2 col-12 col-form-label text-start text-lg-end"
                translate="CONFIRMATION_EQUIPMENT_CHECK_IN_CHECK_OUT_PHONE_LABEL"
            ></label>
            <div class="col-lg-8 col-12">
                <pace-core-text-input
                    [(model)]="model.checkInOutPhone"
                    [parentForm]="equipmentFormChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_CHECK_IN_CHECK_OUT_PHONE_LABEL' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    }
    @if (model.checkInOutPhone) {
        <hr class="separator" />
    }
</div>
